module.exports = __webpack_public_path__ + "static/img/09_克麗緹娜SPA.f9a82a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/09_克麗緹娜SPA.png
// module id = zsL5
// module chunks = 1